<template>
  <div>
    <el-row>
      <el-col>
        <el-button type="text" icon="el-icon-arrow-left" @click="onBack">返回</el-button>
      </el-col>
    </el-row>
    <div class="cs-studyAbroad-workflow" v-loading="isLoading || isSaving">
      <el-row>
        <el-col>
          <el-steps :active="activeStep" process-status="finish" finish-status="success" simple>
            <el-step title="选择项目" :status="getStepStatus(1)" @click.native="onStepItemClick(1)"></el-step>
            <el-step title="缴付款项" :status="getStepStatus(2)" @click.native="onStepItemClick(2)"></el-step>
            <el-step title="报名成功" :status="getStepStatus(3)" @click.native="onStepItemClick(3)"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <el-row class="grid-content">
        <el-col v-if="!isLoading">
          <workflowStep1 ref="workflowStep1" v-show="activeStep === 1" :isReadonly="isReadonly" :dataIn="step1Model"></workflowStep1>
          <workflowStep2 ref="workflowStep2" v-show="activeStep === 2 || activeStep === 3" :isReadonly="isReadonly" :dataIn="step2Model"
            @savePaymentStart="onSavePaymentStart" @savePaymentEnd="onSavePaymentEnd"></workflowStep2>
        </el-col>
      </el-row>
      <el-row class="cs-filter-row">
        <el-col :span="16">
          <el-button v-if="
              !!workflowData.Id && !workflowData.IsCompleted && activeStep === 1
            " size="medium" :loading="isSaving" :disabled="submitBtnDisable || isSaving" type="danger" @click="onCancelWorkflow">取消报名</el-button>
          <el-button v-if="!workflowData.IsCompleted && activeStep !== 1" size="medium" type="primary" @click="onClickPrevious">上一步</el-button>
          <el-button v-if="!workflowData.IsCompleted && activeStep !== 3" size="medium" :loading="isSaving" :disabled="submitBtnDisable || isSaving"
            :type="submitBtnClass" @click="onClickSave">{{ submitBtnText }}</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="completedVisible" top="3vh" class="completedMessageDialog">
      <el-row>
        <el-col>
          <img src="../../../assets/success.png" />
        </el-col>
      </el-row>
      <el-row class="completedMessage">
        <el-col>
          <!-- <span>报名成功，电子收据已发送至{{dataIn.memberModel.Email}}</span> -->
          <span>报名成功</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="primary" @click="onCompletedDialogClose">完成</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
  margin-top: 20px;
  border-top: 1px solid #ced3d9;
}
.cs-studyAbroad-workflow {
  .el-col {
    span {
      height: 40px;
      line-height: 40px;
    }
  }

  .el-button {
    margin-left: 20px;
  }

  .cs-filter-row {
    .el-button:first-child {
      margin-left: 0;
    }
  }
}

.completedMessageDialog {
  .el-row {
    padding: 30px;

    .el-col {
      text-align: center;
    }
  }

  .completedMessage {
    font-weight: bold;
  }
}
</style>

<script>
import workflowStep1 from "./step1";
import workflowStep2 from "./step2";

import {
  getStudentStudyAbroadWorkflow,
  saveStudyAbroadWorkflow,
  removeStudyAbroadWorkflow,
} from "@/service/studyAbroad.service";

let moment = require("moment");
export default {
  props: {
    studentId: Number,
    countryCode: Number,
    currency: Number,
    isBottomPriceMode: Boolean,
    channelId: Number,
  },
  data() {
    return {
      isReadonly: false,
      isLoading: true,
      activeStep: 1,
      currentStepCompleted: false,
      submitBtnDisable: false,
      isSaving: false,
      submitBtnClass: "primary",
      completedVisible: false,
      workflowData: {},
      step1Model: {},
      step2Model: {},
    };
  },
  components: {
    workflowStep1,
    workflowStep2,
  },
  computed: {
    submitBtnText: function () {
      let text = "下一步";

      if (this.activeStep === 2) {
        text = "完成付款";
      }

      return text;
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      this.isLoading = true;
      this.loadWorkflowData();
    },
    onBack() {
      this.$emit("close", true);
    },
    getStepStatus(step) {
      let stepStatus = "finish";

      if (step != this.activeStep) {
        stepStatus = "process";
        if (step < this.workflowData.CurrentStep) {
          stepStatus = "success";
        } else if (step > this.workflowData.CurrentStep) {
          stepStatus = "wait";
        } else if (this.workflowData.CurrentStep === 3 && step === 3) {
          stepStatus = "success";
        }
      }

      return stepStatus;
    },
    onStepItemClick(step) {
      if (step === this.activeStep || step > this.workflowData.CurrentStep)
        return;

      this.activeStep = step;
    },
    loadWorkflowData() {
      getStudentStudyAbroadWorkflow(this.studentId).then((result) => {
        if (result && result.success) {
          this.workflowData = result.data;
          this.initStepModelData();
        }
        this.isLoading = false;
      });
    },
    initStepModelData() {
      this.activeStep = this.workflowData.CurrentStep;
      this.initStep1Model();
      this.initStep2Model();
    },
    initStep1Model() {
      this.step1Model = {
        //If the student is registered from a channel partner,
        //the "Business Type" should set to default value: "ToB" (value: 1)
        businessType:
          this.workflowData.BusinessType ||
          (!!this.channelId
            ? this.GLOBAL.enumBusinessType.ToB
            : this.GLOBAL.enumBusinessType.ToC),
        countryCode: this.workflowData.CountryCode || this.countryCode,
        studentId: this.studentId,
        workflowId: this.workflowData.Id,
        currency: this.workflowData.Currency || this.currency,
        isBottomPriceMode: this.isBottomPriceMode,
        channelId: this.channelId,
        serviceListData: {
          serviceList: this.workflowData.ServiceList.map((i) => ({
            id: i.Id,
            info: {
              serviceId: i.ServiceId,
              serviceName: i.ServiceName,
              currency: this.workflowData.Currency || this.currency,
              itemList: i.ServiceItemList.map((j) => ({
                id: j.Id,
                serviceItemId: j.ServiceItemId,
                name: j.ServiceItemName,
                price: j.SaleAmount,
                modelData: {
                  SalePriceCAD: j.SalePriceCAD,
                  SalePriceCNY: j.SalePriceCNY,
                  BottomPriceCAD: j.BottomPriceCAD,
                  BottomPriceCNY: j.BottomPriceCNY,
                  RangeLimitEnable: j.RangeLimitEnable,
                  RangeLimitType: j.RangeLimitType,
                  RangeLimitValue: j.RangeLimitValue,
                  CountLimitEnable: j.CountLimitEnable,
                  CountLimitType: j.CountLimitType,
                  CountLimitValue: j.CountLimitValue,
                  TimeLimitEnable: j.TimeLimitEnable,
                  TimeLimitType: j.TimeLimitType,
                  TimeLimitValue: j.TimeLimitValue,
                },
              })),
            },
            model: {
              startDate: !i.StartDateText
                ? ""
                : moment(i.StartDateText).toDate(),
              contractId: !i.ContractId ? 0 : i.ContractId,
              discountPercentage: i.DiscountPercentage,
              cashDecreasedAmount: i.CashDecreasedAmount,
              comment: i.Comment,
            },
          })),
        },
      };
    },
    initStep2Model() {
      this.step2Model = {
        studentId: this.studentId,
        workflowId: this.workflowData.Id,
        currency: this.workflowData.Currency || this.currency,
        serviceList: this.workflowData.ServiceList.map((i) => {
          let serviceTotalPrice = i.ServiceItemList.reduce(
            (sum, x) => sum + x.SaleAmount,
            0
          );
          let discountAmount = 0;
          if (!!i.DiscountPercentage) {
            discountAmount = (serviceTotalPrice * i.DiscountPercentage) / 100;
          }
          let serviceData = {
            id: i.Id,
            serviceId: i.ServiceId,
            serviceName: i.ServiceName,
            totalPrice: serviceTotalPrice,
            discountPercentage: i.DiscountPercentage,
            discountAmount: discountAmount,
            cashDecreasedAmount: i.CashDecreasedAmount,
            itemList: i.ServiceItemList.map((j) => ({
              id: j.Id,
              serviceItemId: j.ServiceItemId,
              name: j.ServiceItemName,
              price: j.SaleAmount,
            })),
          };
          return serviceData;
        }),
        model: {
          paymentReceived: this.workflowData.IsPaymentReceived ? 1 : 0,
          businessType: this.workflowData.BusinessType,
          payeeType: this.workflowData.PayeeType,
        },
      };
    },
    setValueForWorkflowData() {
      if (this.activeStep == 1) {
        this.workflowData.BusinessType = this.step1Model.businessType;
        this.workflowData.CountryCode = this.step1Model.countryCode;
        this.workflowData.Currency = this.step1Model.currency;
        this.workflowData.ServiceList =
          this.step1Model.serviceListData.serviceList.map((i) => ({
            Id: i.id,
            ServiceId: i.info.serviceId,
            ServiceName: i.info.serviceName,
            StartDateText: !!i.model.startDate
              ? moment(i.model.startDate).format("YYYY/MM/DD")
              : "",
            ContractId: i.model.contractId == 0 ? null : i.model.contractId,
            DiscountPercentage: i.model.discountPercentage,
            CashDecreasedAmount: i.model.cashDecreasedAmount,
            Comment: i.model.comment,
            ServiceItemList: i.info.itemList.map((j) => ({
              Id: j.id,
              ServiceItemId: j.serviceItemId,
              ServiceItemName: j.name,
              SaleAmount: j.price,
            })),
          }));

        this.step2Model.currency = this.workflowData.Currency || this.currency;
        this.step2Model.model.payeeType = this.workflowData.PayeeType =
          this.workflowData.BusinessType === this.GLOBAL.enumBusinessType.ToB
            ? this.GLOBAL.enumPayeeType.Channel
            : this.GLOBAL.enumPayeeType.Speedup;
      } else if (this.activeStep == 2) {
        const valueFromStep2 = this.step2Model.model;
        this.workflowData.IsPaymentReceived =
          valueFromStep2.paymentReceived == 1 ? true : false;
        this.workflowData.PayeeType = valueFromStep2.payeeType;
      }
      let step = this.activeStep + 1;
      if (step > this.workflowData.CurrentStep) {
        this.workflowData.CurrentStep = step;
      }
    },
    onCompletedDialogClose() {
      this.completedVisible = false;
      this.$emit("close", true);
    },
    saveWorkflowData() {
      this.isSaving = true;
      saveStudyAbroadWorkflow(this.workflowData)
        .then((result) => {
          if (result && result.success && !!result.data) {
            this.workflowData.Id = result.data;

            this.moveToNext(true);
            if (this.workflowData.IsCompleted) {
              this.isReadonly = true;
              this.completedVisible = true;
            } else {
              this.$message.success("保存成功!");
            }
          } else {
            this.$message.error(result.message);
          }
          this.isSaving = false;
        })
        .catch(() => {
          this.isSaving = false;
        });
    },
    async onClickSave() {
      let msg = "";
      switch (this.activeStep) {
        case 1: {
          if (this.step1Model.serviceListData.serviceList.length == 0) {
            msg = "请选择服务";
          } else {
            let startDateEmptyList =
              this.step1Model.serviceListData.serviceList.filter(
                (i) => !i.model.startDate
              );
            if (startDateEmptyList.length > 0) {
              let list = startDateEmptyList.map((i) => i.info.serviceName);
              let serviceNames = list.join(",");
              msg = `服务${serviceNames}未选择日期`;
            }
          }
          break;
        }
        case 2: {
          if (!this.workflowData.IsCompleted) {
            let isSave = await this.$confirm("是否要完成该流程?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                return true;
              })
              .catch(() => {
                return false;
              });
            if (isSave) {
              this.workflowData.IsCompleted = true;
            } else {
              return false;
            }
          }
          break;
        }
      }

      if (!!msg) {
        this.$message.warning(msg);
        return;
      }

      this.setValueForWorkflowData();

      if (this.activeStep != 3) {
        this.saveWorkflowData();
      }
    },
    onClickPrevious() {
      if (this.activeStep > 1) {
        this.activeStep--;
      }
    },
    onCancelWorkflow() {
      this.$confirm("是否撤销该流程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isSaving = true;
          removeStudyAbroadWorkflow(this.workflowData.Id).then((result) => {
            let isSuccess = false;
            if (result && result.success) {
              this.$message({
                message: "撤销流程成功",
                type: "success",
              });

              isSuccess = true;
            } else {
              this.$message.error(result.message);
            }
            this.isSaving = false;

            if (isSuccess) {
              this.$nextTick(() => {
                this.init();
              });
            }
          });
        })
        .catch(() => {
          this.isSaving = false;
        });
    },
    moveToNext(isReload) {
      if (this.activeStep == 1 && isReload) {
        this.initStep2Model();
      }
      this.activeStep++;
    },
    onSavePaymentStart() {
      this.isSaving = true;
    },
    onSavePaymentEnd() {
      this.isSaving = false;
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/main.vue